import { render } from "./AppView.vue?vue&type=template&id=44bff04a"
import script from "./AppView.vue?vue&type=script&lang=js"
export * from "./AppView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__